import React from 'react';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { pieChartHighCharts as PieChartHighCharts } from 'ui/views/pieChartHighCharts';
 *
 * // render
 * <PieChartHighCharts propName='propValue'/>
 */
export const pieChartHighCharts = ( props ) => {
    return (
        <div className='ui-pie-chart-high-charts'>
            <div id={ props.chartId }></div>
        	<div className='ui-pie-chart-high-charts__legends'> { props.legend } </div>
        </div>
    );
};

// set display name
pieChartHighCharts.displayName = 'pieChartHighCharts';

// set default props
pieChartHighCharts.defaultProps = {};

// prop types
pieChartHighCharts.propTypes = {};
